import { ElementType } from "../../library-js/dom-tools/ElementType";
import { ContextMenu } from "./ContextMenu";
import { ContextMenuItem } from "./ContextMenuItem";

export class ContextMenuSeperator extends ContextMenuItem
{
  static readonly type = new ElementType<HTMLElement>( "context--menu--seperator" );
  
  constructor( parent:ContextMenu)
  {
    super( parent );
    this.create();
  }


  _create():void
  {
    this._createElement( ContextMenuSeperator.type );
  }
}